/* This file is automatically generated, do not edit manually! */

/* eslint-disable */

exports.ASHA_MODELS = {
    'Asha230SingleSIM'                          : [ 'Nokia', 'Asha 230' ],
    'Asha230DualSIM'                            : [ 'Nokia', 'Asha 230' ],
    '500'                                       : [ 'Nokia', 'Asha 500' ],
    'Asha500SingleSIM'                          : [ 'Nokia', 'Asha 500' ],
    'Asha500DualSIM'                            : [ 'Nokia', 'Asha 500' ],
    '501'                                       : [ 'Nokia', 'Asha 501' ],
    '501s'                                      : [ 'Nokia', 'Asha 501' ],
    '501.1'                                     : [ 'Nokia', 'Asha 501' ],
    '501.2'                                     : [ 'Nokia', 'Asha 501' ],
    '502'                                       : [ 'Nokia', 'Asha 502' ],
    '503'                                       : [ 'Nokia', 'Asha 503' ],
    '503s'                                      : [ 'Nokia', 'Asha 503' ],
};

/* This file is automatically generated, do not edit manually! */
